<template>

	<!-- Input Section  -->
	<div class="row no-gutters frq-desc-input">
		<div class="col-12 col-md-12 p-0">
			<div class="d-flex">
				<nk-dropdown :ancestor-name="parentName" :data="dropDownData" class="frequentDescsDrp" ref="frequentDescsDrp" v-model="dropDownText" :options="componentOptions.frequentDescriptions" :tabindex="disabled ? false : tabindex" @update:modelValue="valueChanged" @inputTextChangeEmit="inputChanged" :disabled="disabled ? true : null" :inputOpts="inputOpts"></nk-dropdown>
				<!-- Modify Modal Button-->
				<div :class="{ buttons: parentName != 'cells', 'buttons-grid': parentName == 'cells' }">
					<nk-button :options="componentOptions.buttons.btnAdd" :class="{ 'input-disabled': disabled }" :disabled="disable || disabled ? true : null" @click="addDescription"></nk-button>
					<nk-button :options="componentOptions.buttons.modalBtn" :class="{ 'input-disabled': disabled }" :disabled="disabled" @click="modifyModal"></nk-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import EmptyId from '~/statics/empty-id'
	import FrequentDescriptionsModify from '~/components/form/frequent-descriptions/frequent-descriptions-modify'
	import { mapGetters, mapActions } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	export default {
		components: {
			FrequentDescriptionsModify,
		},
		props: {
			options: Object,
			modelValue: String,
			tabindex: { default: 0 },
			disabled: {
				type: Boolean,
				default: false,
			},
			inputOpts: { type: Object, default: null }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				disable: false,
				componentOptions: {
					frequentDescriptions: {
						searchable: true,
						required: true,
						remoteSearch: false,
						hideEmptyMsg: true,
						placeholder: this.$t('input-description'),
						display: function (item) {
							return item.text
						},
						searchableFields: ['text'],
						enableInputTextChangeEmit: true,
					},
					buttons: {
						modalBtn: {
							isPrimary: false,
							class: 'border-0',
							icon: ['fal', 'fa-list-ul'],
						},
						btnAdd: {
							isPrimary: false,
							class: 'border-0',
							icon: ['fal', 'fa-plus'],
						},
					},
				},
				dropDownText: {
					text: this.modelValue || '',
				},
			}
		},
		computed: {
			...mapGetters({
				allFrequentDescriptions: 'frequentdescriptions/all',
			}),
			dropDownData() {
				return this.allFrequentDescriptions.filter(item => (item.entityId === this.options.entityId && item.entityType === this.options.entityType) || (this.options.includePublic && !item.entityId))
			},
			parentName() {
				return this.$parent.$options.name
			}
		},
		mounted() {
			this.refreshFrequentDescription()
			$('input', this.$refs.frequentDescsDrp.$el).on('input', (res) => {
				let typedText = res.target.value
				this.disable = typedText ? false : true
				this.$emit('update:modelValue', typedText)
			})
		},
		beforeUnmount() {
			$('input', this.$refs.frequentDescsDrp.$el).off('input')
		},
		watch: {
			modelValue: {
				deep: true,
				immediate: true,
				handler(val) {
					this.dropDownText = { text: val }
				}
			}
		},
		methods: {
			valueChanged() {
				if (this.dropDownText)
					this.$emit('update:modelValue', this.dropDownText.text)
			},
			inputChanged(val) {
				this.$emit('update:modelValue', val)
			},
			...mapActions({
				refreshFrequentDescription: 'frequentdescriptions/refresh',
			}),
			modifyModal(button, e) {
				e.preventDefault()
				this.showModal({
					component: FrequentDescriptionsModify,
					data: {},
					options: this.options,
				}).then(x => { }).catch(err => { })
			},
			addDescription(button, e) {
				e.preventDefault()
				let text =
					this.dropDownText !== null
						? this.dropDownText.text
						: $('input', this.$refs.frequentDescsDrp.$el).val()
				if (text === '') {
					return
				}
				const wait = this.$wait(this.$refs.frequentDescsDrp.$el, { size: 'small' })
				post(Endpoints.getUrl('frequentDescriptions.modify'), {
					items: [
						{
							id: EmptyId,
							rowState: 'new',
							text: text,
							entityId: this.options.entityId,
							entityType: this.options.entityType,
						},
					],
				})
					.then((response) => {
						wait.end()
						if (response.success) {
							this.refreshFrequentDescription({
								entityId: this.options.entityId,
								entityType: this.options.entityType,
								force: true
							})
							this.$toast(this.$t('msg.create-success'), { type: 'success' })
						}
					})
					.catch((err) => {
						wait.end()
					})
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'frequent-descs-list',
					keyCode: [13], // 13:Enter
					ctrlKey: true,
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (this.disabled) return
						this.modifyModal(sender, e)
					},
				})
			},
		},
	}
</script>

<style></style>
